// @ts-ignore -- JavaScript module has no TypeScript declaration yet.
import { Media } from '../../../../components/Media.js';
import classNames from 'classnames';
import type { SignupMediaPanelProps } from './SignupMediaPanel';

export function SignupMediaPanelFullPage({
  mediaContent,
}: SignupMediaPanelProps) {
  const hasDesktopMedia = !!mediaContent.Media?.Image;

  const containerClass = classNames(
    'hidden lg:flex relative top-0 lg:h-[calc(100dvh-64px)] overflow-hidden flex flex-col justify-between w-full lg:w-1/2 lg:sticky lg:top-0',
  );

  if (!hasDesktopMedia) {
    return <div className={containerClass} />;
  }

  return (
    <div className={containerClass}>
      <div className="pointer-events-none absolute inset-x-0 bottom-6 z-20 flex flex-col items-center justify-center px-4 py-3 md:bottom-8 md:py-4">
        <p className="mb-3 text-center text-white">
          <strong>Timely. Trusted by salons worldwide.</strong>
        </p>
        <div className="flex w-full max-w-5xl flex-nowrap items-center justify-center gap-2 overflow-hidden sm:gap-3 md:gap-4">
          <img
            alt="SSkin"
            src="/static/image/partner-logos/other/sskin-white.png"
            className="w-1/6 min-w-0 object-contain"
          />
          <img
            alt="AHC"
            src="/static/image/partner-logos/other/ahc-white.png"
            className="w-1/6 min-w-0 object-contain"
          />
          <img
            alt="Mamawest"
            src="/static/image/partner-logos/other/mamawest-white.png"
            className="w-1/6 min-w-0 object-contain"
          />
          <img
            alt="ABIC"
            src="/static/image/partner-logos/other/abic-white.png"
            className="w-1/6 min-w-0 object-contain"
          />
          <img
            alt="Haus of Vakai"
            src="/static/image/partner-logos/other/haus_of_vakai-white.png"
            className="w-1/6 min-w-0 object-contain"
          />
          <img
            alt="Jin Soon"
            src="/static/image/partner-logos/other/jinsoon-white.png"
            className="w-1/6 min-w-0 object-contain"
          />
        </div>
      </div>

      <figure className="relative block h-full w-full overflow-hidden">
        <Media umbraco={mediaContent} media={mediaContent.Media} />
      </figure>
    </div>
  );
}
